import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Fade from 'react-reveal/Fade';
import ReactGA from 'react-ga';
import { setDigitalData } from '../../Utilities/Utils.js';

import './MemberMenu.css';

class DGRMemberMenu extends Component {

    componentDidMount(){
        this.props.DGRBackgroundStore.showBlurAndHeader()
        setDigitalData( 'member menu', this.props.DGRStore.club_number );
    }

    selectProduct( product_name ) {
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Member Menu',
            action: this.props.DGRStore.productLabels()[ product_name ]
        });
        this.props.DGRStore.setProductID( product_name );
        this.props.DGRStore.loginOrRedirect().then( path => {
            if ( path && path.indexOf('http:') > -1 ) {
                window.location.href = path;
            } else if ( path ) {
                this.props.history.push( path );
            }
        });
    }

    handlePersonalTraining = (e) => {
        this.selectProduct( 'buy_pt' );
    }

    handleReSignPersonalTraining = (e) => {
        this.selectProduct( 'resign_pt' );
    }

    handleUpgradeMembership = (e) => {
        this.selectProduct( 'upgrade_membership' );
    }

    handleAddFamilyMember = (e) => {
        this.selectProduct( 'add_family' );
    }

    handleAddPrivileges = (e) => {
        this.selectProduct( 'buy_privileges' );
    }

    handleEnrollManageEasyPay = (e) => {
        this.selectProduct( 'easypay' );
    }

    handleEnrollManagePersonalTrainingPIN = (e) => {
        this.selectProduct( 'training_pin' );
    }

    handleLateAcceptance = (e) => {
        this.selectProduct( 'late_acceptance' );
    }

    disableZuora() {
        if ( this.props.DGRStore.values.isZuoraMember ) {
            return "sideButton disabledSideButton";
        } else {
            return "sideButton";
        }
    }

    disableLateAcceptance() {
        if ( this.props.DGRStore.values.member_number && !this.props.DGRStore.values.signing_agreement_number ) {
            return "sideButton disabledSideButton";
        } else {
            return "sideButton";
        }
    }

    getName() {
        return ( this.props.DGRStore.values.first_name ? ', ' + this.toTitleCase( this.props.DGRStore.values.first_name ) : '' );
    }

    toTitleCase( str ) {
        return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    }

    render(){
        return (
            <div className="">
                <Fade>
                <div className="memberMenu">

                    <div className="dgrTitleText">
                        <h2>Welcome{ this.getName() }!</h2>
                    </div>

                    <div className="optionsBox">

                        <button className="sideButton" onClick={ this.handlePersonalTraining }>
                            <div>Buy Personal Training</div>
                        </button>

                        <button className={ this.disableZuora() } onClick={ this.handleReSignPersonalTraining }>
                            <div>Re-Sign Personal Training</div>
                        </button>

                        <button className={ this.disableZuora() } onClick={ this.handleUpgradeMembership }>
                            <div>Upgrade Membership</div>
                        </button>

                        <button className="sideButton" onClick={ this.handleAddFamilyMember }>
                            <div>Add Family Member</div>
                        </button>

                        <button className={ this.disableZuora() } onClick={ this.handleAddPrivileges }>
                            <div>Add Services</div>
                        </button>

                        <button className="sideButton" onClick={ this.handleEnrollManageEasyPay }>
                            <div>Enroll / Manage EasyPay</div>
                        </button>

                        <button className={ this.disableZuora() } onClick={ this.handleEnrollManagePersonalTrainingPIN }>
                            <div>Enroll / Manage Personal Training PIN</div>
                        </button>

                        <button className={ this.disableLateAcceptance() } onClick={ this.handleLateAcceptance }>
                            <div>Late Acceptance</div>
                        </button>

                    </div>
                </div>
                </Fade>
            </div>
        )
    }
}

DGRMemberMenu = inject('DGRStore', 'DGRBackgroundStore','DGRProductStore')(observer( DGRMemberMenu ))
export default DGRMemberMenu;



// WEBPACK FOOTER //
// ./src/components/DGR/MemberMenu/MemberMenu.js